import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Routes from '../../routes';

export default class Airport extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    $(document).on('click', '.is-geo-airports-button', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    let button = $(event.currentTarget),
        input  = button.closest('.field').find('input[type="text"]'),
        query  = button.closest('.form').find('input[type="text"][name="name"]').val(),
        country = button.closest('.form').find('[name="country_id"]').val();

    event.preventDefault();

    button.addClass('is-loading');

    this.logger(`Trying to search airports by city[${query}] in country[${country}]`);

    return this.App.Geo.Airport.search(query, country, (airports) => {
      this.logger('Results:', airports);
      input.val(airports.join(', '));
      button.removeClass('is-loading');
    });

  }
}